module.exports = __webpack_public_path__ + "static/image/history/pc/202103.ver2_0_2.jpg?b6aaf18f";